import React from "react";
import { Link } from "react-router-dom";
import logoImg from "images/schoon_transparent.svg";

export interface LogoProps {
  img?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  img = logoImg,
  className = "w-24"
}) => {
  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block text-primary-6000 focus:outline-none focus:ring-0 ${className}`}
    >
      <img
        className={`block max-h-12 object-cover w-full invert-0 dark:grayscale dark:invert ${className}`}
        src={img}
        alt="Schoon logo"
      />
    </Link>
  );
};

export default Logo;
